export class PickupCorporateConfig {
  startHour = 8;
  endHour = 23;
  leadTimeHours = 4;
  armadaThresholdKg = 20;

  constructor(fields?: Partial<PickupCorporateConfig>) {
    Object.assign(this, fields);
  }
}
